module.exports = __webpack_public_path__ + "media/fuel_types/other-8e349e89.png";